import { useQuery } from '@tanstack/react-query';
import type { ApiError } from '@/lib/api/client';
import { fetchTaskEvents } from '@/services/taskService';
import { queryKeys } from '@/lib/query/queryClient';
import type { TaskEvent } from '@/types/api';

export function useTaskEvents(taskId: string | null) {
  return useQuery<{ items: TaskEvent[] }, ApiError>({
    queryKey: queryKeys.taskEvents(taskId ?? 'none'),
    queryFn: () => fetchTaskEvents(taskId as string),
    enabled: taskId !== null,
  });
}
